// src/utils/platform.js
// 브라우저/OS 감지 유틸 (모바일/데스크톱 + macOS/Windows)

export function detectEnv() {
  const ua = navigator.userAgent || "";
  const uaData = navigator.userAgentData;
  const platform = (uaData?.platform || navigator.platform || "").toLowerCase();

  // 모바일 OS
  const isAndroid = /android/i.test(ua) || /android/i.test(platform);
  const isIOS =
    /iPhone|iPad|iPod/i.test(ua) ||
    // iPadOS 13+가 Mac처럼 보이는 케이스 보정
    (platform === "macintel" && navigator.maxTouchPoints > 1);

  // 데스크톱 OS
  const isMac = /mac/.test(platform) && !isIOS;
  const isWindows = /win/.test(platform);
  const isDesktop = !isAndroid && !isIOS;

  return { isAndroid, isIOS, isDesktop, isMac, isWindows };
}
